import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminSalesContent from "../admin/components/AdminSalesContent";

const SupportExecutiveSalesWrapper = () => {
  return (
    <SupportLayout userRole="SE">
      <AdminSalesContent useOwnLayout={true} />
    </SupportLayout>
  );
};

export default SupportExecutiveSalesWrapper;
